import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import InstallPrompt from './InstallPrompt';
import { applyDir, caricaLingua } from './i18n';
import './responsive.css';

// Apply the persisted language's text direction (RTL for Hebrew) before render.
applyDir();

// Casual image-download friction: block right-click "Save image as…", drag-to-
// save, and iOS long-press-save ON IMAGES ONLY (so normal right-click/selection
// elsewhere still works). This deters casual copying — it can't stop a
// determined user (screenshots, devtools, the raw /uploads URL), for which the
// real protection is the watermark on our own photos + the hotlink guard.
if (typeof document !== 'undefined') {
  const blockOnImage = (e) => { if (e.target && e.target.tagName === 'IMG') e.preventDefault(); };
  document.addEventListener('contextmenu', blockOnImage);
  document.addEventListener('dragstart', blockOnImage);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// SI ASPETTA IL DIZIONARIO PRIMA DI DISEGNARE.
//
// I tre dizionari non stanno piu nel pacchetto principale (erano 113 kB
// compressi su 310, scaricati anche da chi legge in inglese e non ne usa
// nessuno). Adesso arrivano a parte, e questo e l'unico punto in cui si
// aspetta.
//
// Aspettare invece di disegnare subito in inglese e correggere dopo: su una
// pagina ebraica il lampo sarebbe testo inglese con il verso della scrittura
// che si ribalta a meta, ed e peggio del decimo di secondo di attesa. Chi
// apre in inglese non aspetta affatto — caricaLingua() torna subito, perche
// non c'e niente da caricare.
//
// Se il pezzo non arriva, caricaLingua() non rifiuta: il sito si disegna in
// inglese invece di non aprirsi.
caricaLingua().then(() => {
  root.render(
    <>
      <App />
      <InstallPrompt />
    </>
  );
});

// PWA: register the service worker (installable app + basic offline). Kept
// deliberately quiet — failure just means no offline support, never a crash.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}
